import type { Statistic, StatisticDefinition } from '@shared-types/stats.types';
import { StatAggregationType, StatUnit } from '@shared-types/stats.types';

export const getStat = (stat: Statistic, name: string) => stat?.statistics?.find((s) => s.name === name);

const countDecimals = (value: number) => {
  if (Math.floor(value) === value) return 0;
  return value.toString().split('.')[1].length ?? 0;
};

export const getStatUnitMeasureLabel = (type: StatisticDefinition) => {
  if (type.aggregationType === 'PERCENTAGE') {
    return '%';
  }

  switch (type.unit) {
    case StatUnit.KILOMETER:
      return 'km';
    case StatUnit.KILOMETER_PER_HOUR:
      return 'km/h';
    case StatUnit.METER:
      return 'm';
    case StatUnit.METER_PER_SECOND:
      return 'm/s';
    case StatUnit.MINUTE:
      return "'";
    case StatUnit.SECOND:
      return '"';
    default:
      return null;
  }
};

export const getStatNumericValue = (stat: Statistic, type: StatisticDefinition) => {
  const value = getStat(stat, type?.name)?.value;
  if (!value) return null;

  const float = parseFloat(value);

  if (type.aggregationType === StatAggregationType.PERCENTAGE || type.unit) {
    if (countDecimals(float) > 1) {
      return parseFloat(float.toFixed(1));
    }
  }

  return float;
};

export const getStatValue = (stat: Statistic, type: StatisticDefinition) => {
  const value = getStatNumericValue(stat, type);
  if (!value && value !== 0) return '-';

  return value;
};
